import { render, staticRenderFns } from "./downtime.vue?vue&type=template&id=55576f91&"
import script from "./downtime.vue?vue&type=script&lang=js&"
export * from "./downtime.vue?vue&type=script&lang=js&"
import style0 from "./downtime.vue?vue&type=style&index=0&id=55576f91&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports